<div id="wrapper">
  <app-loading-screen></app-loading-screen>
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
  </div>
  <div>
    <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event"
                 (updateSelectBan)="this.selectBan=$event" (updateInitializeData)="this.initializeData()">
    </app-tab-nav>
  </div>
  <div class="allcont logsize m-top-i">
    <div class="basicrow ">
      <div class="container">
        <div class="basicr-line-i">
          <div class="f-btitle autodef">
            <img class="logo" src='../assets/images/ico_preguntasFrecuentes_red-01.png'> Preguntas Frecuentes <a class="ClaroTv">Claro</a><a class="tvmas">tv+</a>
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow roboto-r f-reg f-black m-top m-bott">
      <div class="container">
        <app-collapse [(content)]="this.content"></app-collapse>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
